export default function Icon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0.872695C24 0.326166 23.544 -0.000612711 23.0705 8.62523e-07C22.3126 0.000990237 20.0914 0.00361583 12.5252 0.00504045C7.31799 0.00603184 4.80603 0.00426669 3.61728 0.00262647C2.85628 0.00157664 2.23761 0.60772 2.23761 1.36278L2.23168 22.1629H0.9254C0.414551 22.1629 0.000761952 22.5721 1.0419e-06 23.077C-0.000756812 23.5822 0.412015 23.9941 0.923505 23.9964C1.31234 23.998 2.11601 24 4.25251 24C6.39466 24 7.1463 23.998 7.50491 23.9963C8.02595 23.9939 8.42822 23.5599 8.42822 23.0655C8.42822 22.5497 8.00365 22.1629 7.50297 22.1629H4.03706L4.04298 1.83632H5.92316L7.25249 1.84017H9.3938V4.59152H6.92882C6.2422 4.59152 5.67353 5.08896 5.57061 5.73963C5.55963 5.80899 5.554 5.8799 5.55404 5.95188C5.555 7.45058 5.5579 8.94924 5.56079 10.4476V10.4487V10.4498L5.56407 12.2027C5.56566 13.1175 5.56696 14.0322 5.56755 14.9469C5.56803 15.6978 6.1835 16.3069 6.94302 16.3069H22.5411C23.3018 16.3069 23.9136 15.6966 23.9136 14.9467V5.95165C23.9136 5.20048 23.298 4.59152 22.5385 4.59152H20.0939V1.84017H23.0715C23.6212 1.84017 24 1.34133 24 0.872695ZM11.1992 4.59152V1.84017H18.2886V4.59152H11.1992ZM7.34998 14.4697V6.42865H22.1378V14.4697H7.34998Z"
        fill="#ea580c"
      />
    </svg>
  );
}
